const TESTIMONIALS = [
  {
    quote:
      "I bought a piece from a Harare artist I'd never have discovered otherwise. The packaging was perfect and it arrived in ten days.",
    name: "Aisha M.",
    role: "Collector · London",
  },
  {
    quote:
      "Listing was straightforward and the platform handled everything — the artist keeps the spotlight. Made my first international sale here.",
    name: "Tariq D.",
    role: "Artist · Johannesburg",
  },
  {
    quote:
      "Finally a marketplace that treats African contemporary art as art — not as a category. Clean, considered, easy to browse.",
    name: "Susanne R.",
    role: "Collector · Berlin",
  },
];

export const TestimonialsSection = () => (
  <section data-testid="testimonials-section" className="px-6 md:px-12 lg:px-24 py-20 bg-[#1E3A8A] text-white">
    <p className="label-eyebrow text-[#F4C430]">— Loved by collectors and artists</p>
    <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight font-medium mt-2 text-white">
      What people are saying
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
      {TESTIMONIALS.map((t) => (
        <div key={t.name} className="border border-white/15 p-7 hover:border-[#F4C430] transition-colors">
          <p className="font-serif-display text-xl leading-relaxed font-light">&ldquo;{t.quote}&rdquo;</p>
          <div className="mt-6 pt-5 border-t border-white/15">
            <p className="label-eyebrow text-[#F4C430]">{t.role}</p>
            <p className="mt-1 text-sm text-white/90">— {t.name}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
